<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/module-qcm-response']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'module-qcm-response_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
